import { NodeModel } from '../../../types';
import { NodeWithNestedNodes } from './baseWithNestedNodes.types';
import { drawNestedNodeContent } from './baseWithNestedNodesUtils';

// @ts-ignore
export const baseWitNestedNodesConfig: NodeWithNestedNodes = {
  getCustomConfig(model) {
    return {
      ...this.getNodeConfig(model),
    };
  },

  getNodeConfig() {
    return {};
  },

  getChildNodes(model) {
    return model?.nodeData?.childNodes || [];
  },

  hasFooter(model) {
    return !!this.getChildNodes(model as NodeModel)?.length;
  },

  drawFooterContent(opts) {
    return drawNestedNodeContent(opts);
  },
};
